/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function UsersJuicyIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="users-juicy"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <circle cx={9.592} cy={9.5} r={4.408} stroke={color} fill={color} data-stroke-tone="primary" data-fill-tone="primary" />
          <path d="M16.056 5.342C16.292 5.434 16.354 5.452 16.581 5.566C17.092 5.825 17.55 6.183 17.925 6.615C18.362 7.12 18.681 7.724 18.852 8.369C19.024 9.015 19.046 9.697 18.917 10.352C18.843 10.726 18.721 11.091 18.553 11.433C18.344 11.862 18.066 12.255 17.731 12.595C17.396 12.934 17.007 13.219 16.581 13.434C16.354 13.548 16.292 13.566 16.056 13.658C16.278 13.352 16.341 13.279 16.534 12.953C16.75 12.586 16.932 12.199 17.076 11.798C17.656 10.185 17.599 8.379 16.92 6.806C16.751 6.415 16.545 6.04 16.306 5.687C16.226 5.57 16.139 5.457 16.056 5.342Z" data-tinysvg-shape="path" stroke="none" fill={color} data-fill-tone="primary" />
          <path d="M16.056 5.342A4.408 4.408 0 0 1 16.056 13.658" data-tinysvg-shape="arc" data-tinysvg-arc="14.592 9.5 4.408 4.408 289.392 70.608 0 center" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M3.592 20.583A6.893 6.893 0 0 1 15.592 20.583" data-tinysvg-shape="arc" data-tinysvg-arc="9.592 23.977 6.893 6.893 209.496 330.504 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(128.57)} data-tinysvg-stroke-width="128.57" />
          <path d="M16.485 16.615C18.616 16.893 20.517 18.156 21.592 20.056" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(128.57)} data-tinysvg-stroke-width="128.57" />
          <path d="M16.056 5.342A6.793 6.793 0 0 1 16.056 13.658" data-tinysvg-shape="arc" data-tinysvg-arc="10.683 9.5 6.793 6.793 322.262 397.738 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
